var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"toast",class:{success:_vm.status==0,error:_vm.status==1,process:_vm.status==2,warn:_vm.status==3}},[_c('span',{staticClass:"icon"},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.i18n(_vm.info)))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f18ba46c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toast.vue
// module id = null
// module chunks = 